import { useEffect, useState } from 'react';
import { listScheduled } from '../../shared/api/scheduler.api';

/**
 * Число задач в очереди — для счётчика на вкладке «Отложенные».
 * Ошибку глотаем: счётчик не критичен, вкладка работает и без него.
 */
export function useScheduledCount(): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    listScheduled()
      .then((items) => {
        if (cancelled) return;
        setCount(items.filter((i) => i.status === 'pending' || i.status === 'running').length);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return count;
}
